import { dateFormatEnum } from "../assets/Js/dateFormatEnum";

export const useUTCLocalConvertor = () => {
  return ({ type, date }) => {
    let _date = new Date(date);
    let newDate = null;

    if (type === dateFormatEnum.utc) {
      newDate = new Date(_date.getTime() + _date.getTimezoneOffset() * 60000);
    } else if (type === dateFormatEnum.local) {
      newDate = new Date(
        _date.getTime() - _date.getTimezoneOffset() * 60 * 1000
      );
    }

    return newDate;
  };
};
